// Période globale de l'application, partagée par toutes les pages :
// P&L, écritures et stats vont de startDate à endDate, le bilan est arrêté
// à endDate, la page Sync fetch et régénère sur la même plage.
//
// Défaut : l'exercice en cours entier (1er janvier → 31 décembre). Des écritures
// sont datées du dernier jour du mois (paie, primes assureurs) ; une fin de
// période à aujourd'hui les exclurait et fausserait le résultat.

import { create } from "zustand";
import { persist } from "zustand/middleware";

export function fiscalYearRange(year = new Date().getFullYear()): { startDate: string; endDate: string } {
  return { startDate: `${year}-01-01`, endDate: `${year}-12-31` };
}

interface DateStore {
  startDate: string;
  endDate: string;
  setDateRange: (startDate: string, endDate: string) => void;
}

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export const useDateStore = create<DateStore>()(
  persist(
    (set) => ({
      ...fiscalYearRange(),
      setDateRange: (startDate, endDate) => {
        if (!ISO_DATE.test(startDate) || !ISO_DATE.test(endDate) || startDate > endDate) return;
        set({ startDate, endDate });
      },
    }),
    {
      name: "cartage-date-settings",
      // v1 : la période devient globale et son défaut passe du mois en cours à
      // l'exercice ; on repart du défaut plutôt que d'hériter d'un mois isolé.
      version: 1,
      migrate: () => fiscalYearRange(),
      partialize: (s) => ({ startDate: s.startDate, endDate: s.endDate }),
    },
  ),
);
